import { useEffect, useState } from 'react';

const useResponsiveCanvasSize = () => {
  const [fixedCanvasSize, setFixedCanvasSize] = useState(800);

  useEffect(() => {
    const updateSize = () => {
      const screenWidth = window.innerWidth;
      const screenHeight = window.innerHeight;
      let newSize;

      if (screenHeight < screenWidth) {
        newSize = screenHeight - 125;
      } else {
        newSize = screenWidth - 500;
      }

      newSize = Math.max(350, Math.min(newSize, 800));
      setFixedCanvasSize(newSize);
    };

    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return fixedCanvasSize;
};

export default useResponsiveCanvasSize;
